const toastr = require("toastr");
var buttonClicked = false;

const Juno = function(){
  var priv = {};
  var pub = {};


  priv.set_sessions = function(session_id,production){
    priv.session = new DirectCheckout(session_id, production);
  }

  priv.get_card_token = function(){
    var expirationCard = $("input#transaction_card_expiration").val().split('/')
    var params = {
      cardNumber: $("input#transaction_card_number").cleanVal(),
      holderName: $("input#transaction_credit_card_name").val(),
      securityCode: $("input#transaction_card_cvv").val(),
      expirationMonth: expirationCard[0],
      expirationYear: expirationCard[1],
    }

    return priv.session.getCardHash(params, function (cardHash) {
        priv.card_token = cardHash //token gerado, esse deve ser usado na chamada da API do Checkout Transparente
        $('input#transaction_credit_card_token').val(cardHash);

        $('input#transaction_card_number').remove();
        $('input#transaction_card_expiration').remove();
        $('input#transaction_card_cvv').remove();

        $('form').unbind('submit').trigger('submit');
        $('form').bind('submit', priv.validateSubmit);
      }, function (response) {
        if (response.message.indexOf("Invalid expire date") >= 0)
			window.showToast([['error', 'Data de expiração incorreta.']]);
	    else if (response.message.indexOf("Invalid holder name") >= 0)
			window.showToast([['error', 'Titular do Cartão inválido']]);
        else if (response.message.indexOf("Invalid security code") >= 0)
  			window.showToast([['error', 'Código de segurança incorreto.']]);
  	    else
			window.showToast([['error', 'Cartão Inválido.']]);

        console.log("ERROR: ", response);
		buttonClicked = false;


      })
  }

  priv.disable_enable = function(name, enable) {
	  if (enable) {
		  $('#' + name).show();
		  var selectField = $('#' + name + ' select');
		  selectField.prop( "disabled", false );
		  //selectField.prop("selectedIndex", 0);
		  //selectField.focus().select();
	  } else {
		  var selectField = $('#' + name + ' select');
		  //selectField.prop("selectedIndex", 0);
		  selectField.prop("disabled", true );
		  $('#' + name).hide();
	  }
  }

  priv.switch_payment_method = function(e){
    priv.payment_method = e.currentTarget.value;

    if (e.currentTarget.value == 'credit_card'){
      $('#credit_card_row').show()
	  priv.disable_enable('boleto_installment', false);
	  priv.disable_enable('other_installment', false);
	  priv.disable_enable('credit_card_installment', true);
    } else {
      $('#credit_card_row').hide()
	  priv.disable_enable('credit_card_installment', false);
	  if (e.currentTarget.value == 'boleto_pix') {
	  	priv.disable_enable('boleto_installment', false);
  	  	priv.disable_enable('other_installment', true);
	  } else {
	  	priv.disable_enable('other_installment', false);
		priv.disable_enable('boleto_installment', true);
	  }
    }
  }


  priv.validateSubmit = function(e){
    e.preventDefault();
    e.stopPropagation();

	if (buttonClicked) {
		return false;
	}
	window.showToast([['sucess', 'Aguarde processando']]);
	buttonClicked = true;

  	if ($('#transaction_person_attributes_name').val().trim().indexOf(" ") < 0) {
  		toastr.error('Campo nome, deve conter nome e sobrenome!.', 'Erro!');
		buttonClicked = false;
  		return false;
  	}

    if (priv.payment_method == 'credit_card'){
      priv.get_card_token();
      return false
    }

    // $('input#transaction_sender_hash').val(PagSeguroDirectPayment.getSenderHash());
    $('form').unbind('submit').trigger('submit');

    return false
  }

  pub.init = function(session_id, production){
    priv.set_sessions(session_id, production);

    $('form').on('submit', priv.validateSubmit);
    $('#transaction_card_number').mask("0000 0000 0000 0000");
    $('#transaction_card_expiration').mask("00/0000");
    $('#transaction_person_attributes_birth_at').mask("00/00/0000");
    $('#transaction_payment_method').on('change', priv.switch_payment_method).trigger('change');
	$('#transaction_card_expiration').blur(function() {
		var exp = $('#transaction_card_expiration').val();
		if (exp.length < 7) {
			$('#transaction_card_expiration').val(exp.replace("/","/20"));
		}
	});

	$('#btn_help')[0].href = $('#btn_help')[0].href.replace('http://help/?', atob("aHR0cHM6Ly93YS5tZS81NTU0OTE0Njg4MTU/dGV4dD0="));

  }

  return pub;
}()

export default Juno;
